module.exports = __webpack_public_path__ + "img/x-circle@1x.0b471bc4.svg";